import { spawnYesNoDialog } from "$root/components/spawnable/yes-no-dialog";
import { Text } from "@mdotm/shadcn/legacy/components";

export type SpawnDeleteTagOptionDialogParams = {
	investmentCount: number;
};

export function spawnDeleteTagOptionDialog(params: SpawnDeleteTagOptionDialogParams): Promise<boolean> {
	return spawnYesNoDialog({
		size: "medium",
		header: "Are you sure you want to delete this option?",
		yesButton: "Proceed",
		noButton: "Cancel",
		children: (
			<>
				<Text type="Body/L/Book" as="p">
					This option will be deleted <strong>from all your workspaces.</strong>
				</Text>
				<Text type="Body/L/Book" as="p">
					This action will affect tables and filters using it.
				</Text>
			</>
		),
	});
}
